module.exports = __webpack_public_path__ + "static/media/logo1.afea5c2d.png";